import React, { useEffect, useState } from "react";
import TaskCreation from "./TaskCreation";
import { useAuth } from "../../../../firebase/AuthProvider";
import { getInterimTemplates } from "../../../../services/taskServices/TaskService";
import InterimTemplateResponse from "../../../../interfaces/task/InterimTemplateResponse";
import Select, { SingleValue } from "react-select";
import TaskCreationFromTemplate from "./TaskCreationFromTemplate";
import backarrowbtn from "../../../../assets/images/backarrowbtn.svg";
import './taskcreation.css';

interface OptionType {
  value: string;
  label: string;
}

const TaskCreationPage: React.FC = () => {
  const { currentUser } = useAuth();

  const [templates, setTemplates] = useState<InterimTemplateResponse[]>([]);
  const [templateOptions, setTemplateOptions] = useState<OptionType[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<string>();

  useEffect(() => {
    const fetchTemplates = async () => {
      if (currentUser) {
        const authToken = await currentUser.getIdToken();
        const response = await getInterimTemplates(authToken);
        if (response) {
          setTemplates(response);
        }
      }
    };

    fetchTemplates();
  }, []);

  useEffect(() => {
    const formattedTemplates = templates.map((template, index) => ({
      value: template.id.toString(),
      label: template.title,
    }));

    setTemplateOptions(formattedTemplates);
  }, [templates]);

  const handleTemplateChange = (template: SingleValue<OptionType>) => {
    if (template) {
      setSelectedTemplate(template.value);
    }
  };

  return (
    <>
      <div className={` ${selectedTemplate && 'select_common_card'}`}>
        {selectedTemplate && (
          <>
            <div className="top border_tittle">
              <div className="top_bar_tittle">
                <h2>
                  <span onClick={() => setSelectedTemplate(undefined)} className="cursor-pointer">
                    <img src={backarrowbtn} alt="back arrow" className="icon_sm" />
                  </span>
                  New Task
                </h2>
              </div>
            </div>
              <TaskCreationFromTemplate
                template={templates.find(
                  (e) => e.id == parseInt(selectedTemplate)
                )}
              />
          </>
        )}
        {!selectedTemplate && (
          <>
            {/* <div className="top">
              <div className="top_bar_tittle">
                <h2>Add Task</h2>
              </div>
            </div> */}
            <div className="add_task_flx">
              <div className="common_card">
                <TaskCreation />
              </div>
              <div className="or_with">
                <span>or</span>
              </div>
              <div className="common_card MODIFY_THIS">
                <div className="top border_tittle">
                  <div className="top_bar_tittle">
                    <h2>Select From Template</h2>
                  </div>
                </div>
                <div className="custom_input_flled">
                  <label htmlFor="requiredFiles">Template{" "}</label>
                  <Select
                    options={templateOptions}
                    onChange={handleTemplateChange}
                    value={templateOptions.filter(
                      (option) => option.value === selectedTemplate
                    )}
                     className="react-select-container react-select-container_lg"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TaskCreationPage;
